import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import TextField from '../FormFields/TextField';
import Button from '../Button/Button';
import {
  sendForm,
  sendTicketFreshdesk,
} from '../../../redux/modules/contactForm';
import './ContactForm.scss';

let ContactForm = props => {
  const [captcha, setCaptcha] = useState('');
  const [captchaError, setCaptchaError] = useState(false);
  const canvasRef = useRef(null);

  const handleSubmit = async form => {
    setCaptchaError(false);
    if (form.captcha !== captcha) {
      setCaptchaError(true);
    } else {
      const copy = { ...form };
      delete copy.captcha;
      if (props.hasFreshdesk) {
        props.sendTicketFreshdesk(copy);
      } else {
        props.sendForm(copy);
      }
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    setCaptcha(result);
    drawCaptcha(result);
  };

  const drawCaptcha = captchaText => {
    const canvas = canvasRef.current;
    if (!!canvas) {
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = '20px Arial';
      ctx.fillText(captchaText, 20, 30);
    }
  };

  return (
    <div className="form-contatto">
      {!props.isSent ? (
        <form onSubmit={props.handleSubmit(handleSubmit)} noValidate>
          <h3>Form di contatto</h3>
          <div className="form-group">
            <Field
              name="name"
              component={TextField}
              type="text"
              label="Nome e Cognome"
            />
          </div>
          <div className="form-group">
            <Field
              name="email"
              component={TextField}
              type="email"
              label="Email"
            />
          </div>
          <div className="form-group">
            <Field
              name="phone"
              component={TextField}
              type="text"
              label="Telefono"
            />
          </div>
          <div className="form-group">
            <Field
              name="message"
              component={TextField}
              type="textarea"
              label="Messaggio"
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <canvas
              ref={canvasRef}
              width={120}
              height={40}
              style={{ border: '1px solid #000' }}
            ></canvas>
          </div>
          <div className="form-group" style={{ width: '100%' }}>
            <Field
              name="captcha"
              component={TextField}
              type="test"
              label="Inserisci il testo riportato qui sopra"
            />
          </div>
          {captchaError && (
            <div style={{ color: 'red', marginBottom: 16 }}>
              Il testo inserito non corrisponde a quello riportato
            </div>
          )}
          <Button type="submit" className="btn btn-thick btn-primary">
            Invia messaggio
          </Button>
          {!!props.error && (
            <div
              class="alert alert-danger"
              role="alert"
              style={{ marginTop: 30 }}
            >
              E' avvenuto un errore durante l'invio del messaggio. Ti preghiamo
              di riprovare oppure di contattarci telefonicamente.
            </div>
          )}
        </form>
      ) : (
        <div class="alert alert-success" role="alert">
          Il messaggio è stato inviato correttamente. Sarai ricontatto il prima
          possibile.
        </div>
      )}
    </div>
  );
};

const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Richiesto';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Indirizzo email non valido';
  }

  if (!values.name) {
    errors.name = 'Richiesto';
  }

  if (!values.message) {
    errors.message = 'Richiesto';
  }

  return errors;
};

const mapStateToProps = state => ({
  storeId: state.store.data.storeId,
  hasFreshdesk: state.store.data.features.hasFreshdesk,
  sending: state.contactForm.sending,
  isSent: state.contactForm.isSent,
  error: state.contactForm.error,
});

ContactForm = connect(mapStateToProps, { sendForm, sendTicketFreshdesk })(
  ContactForm
);

export default reduxForm({
  form: 'contattaci',
  validate,
  enableReinitialize: true,
})(ContactForm);
